var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.1416 6.20312L10.4999 10.4615L17.8083 6.22812",
    stroke: "#DD9E0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.0115V10.4531",
    stroke: "#DD9E0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4917 11.0411V12.3578C2.4917 13.5078 3.3167 14.9078 4.32503 15.4661L8.77503 17.9411C9.72503 18.4661 11.2834 18.4661 12.2334 17.9411L16.6834 15.4661C17.6917 14.9078 18.5167 13.5078 18.5167 12.3578V7.64115C18.5167 6.49115 17.6917 5.09115 16.6834 4.53281L12.2334 2.05781C11.2834 1.53281 9.72503 1.53281 8.77503 2.05781L4.32503 4.53281C3.3167 5.09115 2.4917 6.49115 2.4917 7.64115",
    stroke: "#DD9E0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxOrange);
export default __webpack_public_path__ + "static/media/box-orange.2c439086c9d798d9f82d69a1c96abfc2.svg";
export { ForwardRef as ReactComponent };